<template>
  <div class="work-container">
    <!-- 标题栏 -->
    <!-- 顶部导航栏 -->
    <div class="nav-bar">
      <div class="back-btn" @click="goBack">
        <i class="el-icon-arrow-left back-icon"></i>
      </div>
      <div class="nav-title" style="margin-right: 15px;">{{ title }}</div>
      <div class="nav-actions">
        <i class=" action-icon"></i>
        <i class=" action-icon"></i>
      </div>
    </div>

    <!-- 功能模块列表 -->
    <div class="work-cards">
      <div
        class="work-card"
        v-for="card in workCardList"
        :key="card.id"
        @click="toVideo('work',card)"
      >
        <img :src="card.icon" class="icon-img" />
        <div class="card-content">
          <div class="card-title">{{ card.title }}</div>
          <div class="card-desc">{{ card.desc }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { anchorTextListDictInfoWorkType } from "@/api/video";
export default {
  name: "Work",
  data() {
    return {
      title: "工作中心",
      workCardList: [
       
      ],
    };
  },
  created() {
    this.getanchorTextListDictInfoWorkType();
  },
  methods: {
    async getanchorTextListDictInfoWorkType() {
      const res = await anchorTextListDictInfoWorkType();
      console.log(res);
      if (res.data.code === 200) {
        this.workCardList = res.data.data.slice(0,6);
      }
    },
    goBack() {
      this.$router.back();
    },
    toVideo(source,card) {
      this.$router.push({
        path: "/write",
        query: {
          source: source,
          cardId: card.id,
          cardTitle: card.title,
          href: card.href,
        },
      });
    },
  },
};
</script>

<style scoped>
.work-container {
  display: flex;
  flex-direction: column;
  height: 100vh;

  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
  background: #f9fafb;
}

/* 顶部导航栏 */
.nav-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 44px;
  padding: 0 16px;
  background-color: #fff;
  /* background-color: #bcdeff; */
}

.back-btn {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.back-icon {
  font-size: 18px;
  color: #000;
}

.nav-title {
  font-size: 18px;
  font-weight: 600;
  color: #000;
}

.nav-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.action-icon {
  font-size: 18px;
  color: #000;
  cursor: pointer;
}

/* 功能模块列表 */
/* 卡片容器：2列网格布局 */
.work-cards {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  /* 两列平分 */
  gap: 20px;
  /* 卡片之间的间距 */
}

/* 单个卡片样式 */
.work-card {
  display: flex;
  align-items: center;
  padding: 16px;
  background-color: #fff;
  border-radius: 4px;
}

/* 卡片图标（网络图片替代） */
.work-card .icon-img {
  width: 24px;
  height: 24px;
  object-fit: cover;
  margin-right: 12px;
  border-radius: 4px;
}

/* 卡片文字区域 */
.card-content .card-title {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin-bottom: 4px;
}

.card-content .card-desc {
  font-size: 12px;
  color: #999;
}

/* 卡片列表：一行三列布局（Grid更简洁） */
.card-list {
  display: flex;
  justify-content: space-between;
}

/* 单个卡片：垂直排列（图片在上，标题在下） */
.card-item {
  width: 31%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 18px 0;
  background-color: #fff;
  border-radius: 8px;
}

/* 卡片图片样式 */
.card-img {
  width: 50px;
  /* 图片宽度铺满卡片 */
  object-fit: cover;
  /* 图片不变形，覆盖容器 */
  border-radius: 6px;
  margin-bottom: 12px;
  /* 图片与标题的间距 */
}

/* 卡片标题样式 */
.card-title {
  font-size: 16px;
  color: #333;
  font-weight: 500;
  /* 标题居中 */
}
</style>
